import ModalVideo from 'modal-video';

document.addEventListener('DOMContentLoaded', function() {
  new ModalVideo('.js-modal-btn', {
    // github: https://github.com/appleple/modal-video
    // youtube-doc: https://developers.google.com/youtube/player_parameters#Parameters
    channel: 'youtube',
    youtube: {
      autoplay: 0,        // 自動再生：1=ON、0=OFF
      controls: 1,        // コントロールボタン：1=表示、0=非表示
      rel: 0,             // 関連動画：0=非表示、1=表示
      modestbranding: 1,  // YouTubeロゴ縮小：1=小さく、0=通常
      fs: 1,              // フルスクリーンボタン：1=表示、0=非表示
      playsinline: 1      // iOS インライン再生：1=ON、0=OFF
    }
  });
});